import React, { Component } from 'react';
import './RecommendedReportsPage.css';
import Page from '../../components/page/Page';
import Card from '../../components/card/Card';
import Label from '../../components/label/Label';
import Divider from '../../components/divider/Divider';
import history from '../../history';
import models from '../../model/models';
import mainAPI from "../../api/MainAPI";
import UpdateTitle from '../../components/updateTitle/UpdateTitle';
import ReportsTabBar from "../../components/reportsTabBar/ReportsTabBar";
import ReportCard from "../../components/reportCard/ReportCard";



export default class RecommendedReportsPage extends Component {
	constructor(props) {
		super(props);
		this.state = {
			narcLockEnabled: false,
		};
	}
	componentDidMount = async () => {
		this.subId = models.drug_type.onChange(this._typesChanged);
		const integrations = await mainAPI.integration.all() || []
		const {enabled = false} = integrations.find(({name = ''}) => name.toLowerCase() === 'NarcLock'.toLowerCase()) || {}
		if (enabled) this.setState({narcLockEnabled: true})
	};

	componentWillUnmount = () => {
		models.drug_type.unsubscribe(this.subId);
	};

	_typesChanged = () => {
		let drug_types = models.drug_type.allowed();
		this.setState({ drug_types });
	};


	rendernarcLockReports = () => {
		const {narcLockEnabled} = this.state
		if (narcLockEnabled) {
			return (
				<ReportCard url="/reports/narc-lock-lock-audit-report" title="narcLock" description="Lock audit report." />
			)
		}
		return  (<> </>);
	}

	_renderTypeReports = () => {
		let drug_types = this.state.drug_types;
		let display = [];
		for (let i in drug_types) {
			display.push(
				<ReportCard
					key={i}
					url={'/reports/' + drug_types[i].id}
					title={drug_types[i].name}
					description={`Shows you the ${drug_types[i].name} you have on hand.`}
				/>
			);
		}
		return display;
	};

	renderMultiAgencyReports = () => {
		if (localStorage.num_additional_groups > 0) {
			return (
				<>
					<ReportCard
						url="/reports/inventory-for-all-agencies"
						title="All Agency Inventory"
						description="Shows you the total current inventory you have on hand for all of your agencies."
					/>
					<ReportCard
						url="/reports/administered-for-all-agencies"
						title="All Agency Administered"
						description="Shows you all administered drugs for all of your agencies."
					/>
					<ReportCard
						url="/reports/wasted-for-all-agencies"
						title="All Agency Wasted"
						description="Shows you all wasted drugs for all of your agencies."
					/>
				</>
			);
		}
	};

	render() {
		return (
			<Page className="g-recommended-reports-page">
				<UpdateTitle newTitle="Reports" originalTitle="LogRx" />
				<Card className="main">
					<ReportsTabBar/>
					<Divider />
					<div className="reports">
						{this.renderMultiAgencyReports()}
						<ReportCard
							url="/reports/inventory"
							title="Inventory"
							description="Shows you the total current inventory you have on hand."
						/>
						<ReportCard
							url="/reports/supply"
							title="Supply"
							description="Shows you the total inventory that has not been deployed."
						/>
						<ReportCard url="/reports/wasted" title="Drugs Wasted" description="Shows you the wasted drugs." />
						<ReportCard
							url="/reports/drug-transfer"
							title="Drugs Transferred"
							description="Shows you drugs that have changed boxes."
						/>
						<ReportCard
							url="/reports/unit-transfers"
							title="Unit Transfers"
							description="Shows you boxes that have changed units."
						/>
						<ReportCard
							url="/reports/drug-checks"
							title="Drug Checks"
							description="A history of every drug that has been checked."
						/>
						<ReportCard
							url="/reports/box-checks"
							title="Box Checks"
							description="A history of every box that has been checked. (including reseals)"
						/>
						<ReportCard
							url="/reports/administered"
							title="Drugs Administered"
							description="Shows you administered drugs."
						/>
						<ReportCard
							url="/reports/expiring"
							title="Expiring Drugs"
							description="Shows you drugs that will expire in the next 60 days. Excludes expired drugs."
						/>
						<ReportCard url="/reports/expired" title="Expired Drugs" description="Shows you expired drugs." />
						<ReportCard url="/reports/discrepancy" title="Discrepancy" description="Shows any unusual behavior." />
						{this._renderTypeReports()}
						{this.rendernarcLockReports()}
					</div>
				</Card>
			</Page>
		);
	}
}



// WEBPACK FOOTER //
// ./src/pages/recommendedReportsPage/RecommendedReportsPage.jsx